import { render } from "./About_Us.vue?vue&type=template&id=c49975ee"
import script from "./About_Us.vue?vue&type=script&lang=js"
export * from "./About_Us.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Administrator\\betaver_webpage\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__